import { createContext, useContext } from 'react';

export type HostChromeContextValue = {
  /** When true, host header is hidden and assemble-tray should use full viewport height. */
  trayAssemblyFullBleed: boolean;
};

export const HostChromeContext = createContext<HostChromeContextValue | null>(
  null
);

export const useHostChrome = (): HostChromeContextValue =>
  useContext(HostChromeContext) ?? { trayAssemblyFullBleed: false };
